import axios from "src/lib/axios";

//sample find all admin
export const getSampleList = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
}) => {
  return axios.get(`/requests/samples/admin`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      order_case: "desc",
    },
  });
};
export const getSampleRequest = (id) => axios.get(`/requests/samples/${id}`);
export const patchStatusSampleRequest = (info) => {
  return axios.patch(`/requests/samples/manage-detail`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};
